module.exports = __webpack_public_path__ + "static/media/ico-tarjeta_0003_master.6ecfbe3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/checkout/payment-options/ico-tarjeta_0003_master.jpg
// module id = 124
// module chunks = 0